import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusyService {

  state: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  setState(prop) {
    this.state.next(prop);
  }

  public isBusy(): Observable<boolean> {
    return this.state.asObservable();
  }
}
